import React from 'react';

// Web is Android-first promo only: anyone trying to log in / sign up in a
// browser is sent here to install the app. (Shared event links still open the
// guest map so people can preview an event without installing.)
const PLAY_STORE_URL =
  'https://play.google.com/store/apps/details?id=community.linksy.app';

const DownloadAppPage = () => {
  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        padding: '24px',
        background: 'linear-gradient(180deg, #ffffff 0%, #f8fafc 100%)',
        fontFamily: "'Outfit', -apple-system, BlinkMacSystemFont, sans-serif",
      }}
    >
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Outfit:wght@400;500;600;700;800&display=swap');
      `}</style>

      {/* Logo */}
      <div style={{ display: 'flex', alignItems: 'center', gap: '2px', marginBottom: '28px' }}>
        <span style={{ fontSize: '40px', fontWeight: 800, color: '#1f2937' }}>L</span>
        <svg viewBox="0 0 40 55" style={{ width: '30px', height: '42px', marginBottom: '-6px' }}>
          <path d="M20 2 C9 2 2 10 2 20 C2 34 20 53 20 53 C20 53 38 34 38 20 C38 10 31 2 20 2 Z" fill="none" stroke="#2c2c2c" strokeWidth="2.5" />
          <circle cx="20" cy="14" r="4" fill="#2c2c2c" />
          <ellipse cx="20" cy="24" rx="5.5" ry="4" fill="#2c2c2c" />
          <circle cx="11" cy="16" r="3" fill="#2c2c2c" />
          <ellipse cx="11" cy="24" rx="4" ry="3" fill="#2c2c2c" />
          <circle cx="29" cy="16" r="3" fill="#2c2c2c" />
          <ellipse cx="29" cy="24" rx="4" ry="3" fill="#2c2c2c" />
        </svg>
        <span style={{ fontSize: '40px', fontWeight: 800, color: '#1f2937' }}>nksy</span>
      </div>

      <h1 style={{ fontSize: '28px', fontWeight: 700, color: '#111827', margin: '0 0 12px' }}>
        Get the Linksy app
      </h1>
      <p style={{ fontSize: '16px', color: '#6b7280', maxWidth: '420px', lineHeight: 1.5, margin: '0 0 32px' }}>
        Linksy lives on your phone. Download it on Android to discover and join
        events on the map around you.
      </p>

      {/* Google Play button */}
      <a
        href={PLAY_STORE_URL}
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: '12px',
          background: '#111827',
          color: 'white',
          textDecoration: 'none',
          padding: '14px 28px',
          borderRadius: '14px',
          fontSize: '16px',
          fontWeight: 600,
          boxShadow: '0 8px 24px rgba(0,0,0,0.18)',
        }}
      >
        <svg width="24" height="24" viewBox="0 0 512 512" fill="currentColor">
          <path d="M325.3 234.3 104.6 13l280.8 161.2-60.1 60.1zM47 0C34 6.8 25.3 19.2 25.3 35.3v441.3c0 16.1 8.7 28.5 21.7 35.3l256.6-256L47 0zm425.2 225.6-58.9-34.1-65.7 64.5 65.7 64.5 60.1-34.1c18-14.3 18-46.5-1.2-60.8zM104.6 499l220.7-221.3 60.1 60.1L104.6 499z" />
        </svg>
        Get it on Google Play
      </a>

      <p style={{ fontSize: '13px', color: '#9ca3af', marginTop: '40px' }}>
        © {new Date().getFullYear()} Linksy
      </p>
    </div>
  );
};

export default DownloadAppPage;
